export default __webpack_public_path__ + "static/media/bannerMb.afa3aff6.png";